<template>
<button class="storeswitch-btn" @click="findStores">
  Show stores near me
</button>
</template>

<script>
import getDistance from 'geolib/es/getDistance';
import EventBus from '../utils/event-bus';
import Cookies from 'js-cookie';
import axios from 'axios';

export default {
  name: "FinderLocal",
  data() {
    return {

      stores: [],

      query: '',

      hasResults: false,

      isEmpty: false,

      isLoading: false,

      localStores: [],

      localStore: false,

      filteredSuggestions: [],

    };
  },
  props: {
    searchId: String
  },
  methods: {

    findStores(suggestion) {

      var localStores = [];
      var crowiesGeo = Cookies.get('crowiesGeo');
      console.log(crowiesGeo);

      if (typeof crowiesGeo !== 'undefined') {
        crowiesGeo = JSON.parse(crowiesGeo);
        // console.log('found saved geo data');
        // console.log(crowiesGeo);
      } else {
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        var isEdge = false;
        if (document.documentMode || /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent)) {
          isEdge = true;
        }
        if (!isIE11) {
          if (isEdge) {
            var IPGeolocationAPI = require('../ip-geolocation-api-javascript-sdk-edge');
          } else {
            var IPGeolocationAPI = require('ip-geolocation-api-javascript-sdk');
          }
          var ipgeolocationApi = new IPGeolocationAPI('489c10faf7f94f2abc84cfc9a658330f', true);
          ipgeolocationApi.getGeolocation(saveGeo);
        }
      }

      if (typeof crowiesGeo !== 'undefined') {
        stores.forEach(store => {
          var dist = getDistance(
              { latitude: crowiesGeo.lat, longitude: crowiesGeo.lng },
              { latitude: store.lat, longitude: store.lng }
          );
          dist = dist / 1000; // convert to kms
          store.distance = dist.toFixed(2);
          localStores.push(store);
        });

        localStores.sort(function(a, b) {
            return a.distance - b.distance;
        });

        EventBus.$emit('MAP_POPULATE', this.searchId, localStores);
      }

      return false;

    },

    displayStore(store) {


      return false;

    },

  },
  mounted() {

    // console.log(this.localStore);

    // get stores array
    if (typeof window.stores !== 'undefined') {
      this.stores = window.stores;
      // console.log(this.stores);
    }

    EventBus.$on('LOCALSTORE_SET', (localStore) => {
      this.localStore = localStore;
    });

  }
};
</script>

<style scoped>
</style>